import { fetchAll, fetchFiltered, addBank, show, edit } from '@/api/banks'
import { t } from '@/lib/i18n'

const state = {
  all: [],
  isLoading: false,
  bankById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const bank = await show(id)
      commit('setBankById', bank)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const banks = await fetchAll()
      commit('setAll', banks)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const banks = await fetchFiltered(queriesParams)
      commit('setAll', banks)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addBank(data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: t(e.message) || e
      },
      { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: t(e.message) || e
      },
      { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.bankById = null
  },

  setAll (state, banks) {
    state.all = banks
  },

  setBankById (state, bank) {
    state.bankById = {
      id: bank.id,
      name: bank.name,
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
